import React from "react";
import { Slider, Box } from "@mui/material";

const CustomColorSlider = ({ value, valueLabelFormat }) => {
  const colors = {
    1: "#006400", // Dark Green
    2: "#228B22", // Forest Green
    3: "#32CD32", // Lime Green
    4: "#7CFC00", // Lawn Green
    5: "#ADFF2F", // Green Yellow
    6: "#FFFF00", // Yellow
    7: "#FFBF00", // Orange-yellow
    8: "#FF8000", // Orange
    9: "#FF4000", // Dark orange
    10: "#FF0000", // Red
  };

  const getCustomTrack = (props) => {
    const stepWidth = 100 / 10; // 9 intervals between 10 steps

    console.log("value", value);

    return (
      <span {...props}>
        {Object.entries(colors).map(([step, color], index) => (
          <span
            key={step}
            style={{
              position: "absolute",
              height: "10%",
              width: `${stepWidth}%`,
              left: `${index * stepWidth}%`,
              backgroundColor: color,
            }}
          />
        ))}
      </span>
    );
  };

  return (
    <Box sx={{ width: 150 }}>
      <Slider
        value={11 - value}
        step={1}
        marks
        min={1}
        max={10}
        valueLabelDisplay="auto"
        readOnly={true}
        components={{ Track: getCustomTrack }}
        scale={(x) => 11 - x} // Reverse the scale
        valueLabelFormat={valueLabelFormat} // Reverse the value label
        sx={{
          "& .MuiSlider-thumb": {
            backgroundColor: colors[Math.round(value)],
          },
          "& .MuiSlider-rail": {
            opacity: 0,
          },
        }}
      />
    </Box>
  );
};

export default CustomColorSlider;
